import isObject from "./isObject.js";
var objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function object() {
  }
  return function(proto) {
    if (!isObject(proto))
      return {};
    if (objectCreate)
      return objectCreate(proto);
    object.prototype = proto;
    var result = new object();
    return object.prototype = void 0, result;
  };
}();
export {
  baseCreate as default
};
//# sourceMappingURL=_baseCreate.js.map
